import {
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CustomerSelectionComponent } from '@spartacus/asm/components';
import { AsmService } from '@spartacus/asm/core';
import { AsmConfig,CustomerSearchPage } from '@spartacus/asm/root';
import { User, TranslatePipe } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DirectionService, LaunchDialogService, FormErrorsComponent } from '@spartacus/storefront';
import { KnBrAsmMainUiComponent } from '../kn-br-asm-main-ui.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'cx-customer-selection',
    templateUrl: './kn-br-customer-selection.component.html',
    styleUrls: ['./kn-br-customer-selection.component.scss'],
    encapsulation: ViewEncapsulation.None,
    // tslint:disable-next-line:no-host-metadata-property
    host: {
        '(document:click)': 'onDocumentClick($event)',
    },
    imports: [ReactiveFormsModule, FormErrorsComponent, KnBrAsmMainUiComponent, AsyncPipe, TranslatePipe]
})
export class KnBrCustomerSelectionComponent extends CustomerSelectionComponent implements OnInit, OnDestroy {
  constructor(protected fb: UntypedFormBuilder, protected asmService: AsmService, protected config: AsmConfig, protected directionService: DirectionService,protected launchDialogService: LaunchDialogService) {
    super(fb, asmService, config, directionService,launchDialogService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onSubmit(): void {
    if (this.customerSelectionForm.valid && !!this.selectedCustomer) {
      this.submitEvent.emit({ customerId: this.selectedCustomer.uid });
    } else {
      this.customerSelectionForm.markAllAsTouched();
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
